<app-navbar></app-navbar>

<!-- Blog details -->
    <section class="our-articles bg-light-theme section-padding pt-0">
        <div class="blog-page-banner"></div>
        <div class="container-fluid">
            <div class="row">
                <aside class="col-lg-3">
                <!-- <app-blogleftsidebar 
                [selectedCategory]="selectedCategory"

                (categorySelected)="filterCategory($event)">
                ></app-blogleftsidebar> -->
            </aside>
                <div class="col-lg-7 blog-inner clearfix">
                    <div class="main-box padding-20 full-width">
                        <div class="breadcrumb-wrpr">
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item"><a routerLink="/" class="text-light-black">Home</a>
                                </li>
                                <li class="breadcrumb-item"><a routerLink="/blog" class="text-light-black">Blog</a>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">Blog Details</li>
                            </ul>
                        </div>
                        <div class="post-wrapper mb-xl-20">
                            <img src="assets/img/blog-details/822x337/image-1.jpg" class="img-fluid full-width" alt="#">
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="blog-meta mb-xl-20">
                                    <h2 class="blog-title text-light-black">LA BURGERS</h2>
                                    <p class="text-light-white">LA BURGERS is thrilled to announce the opening of our second Melbourne location — Suite 306, 111 Overton Rd, Williams Landing VIC 3027. The new store opens with an expanded menu featuring local-exclusive items, extended family deals, and morning-to-late evening hours to serve the neighbourhood.</p>
                                </div>
                                <div class="blog-meta mb-xl-20">
                                    <h5 class="blog-title text-light-black">Why do we choose it?</h5>
                                    <p class="text-light-white">
                                        People don’t choose a restaurant only for the food—they choose it for the entire experience. At LA Burgers, customers come for the fresh ingredients, bold flavors, and the consistency that makes every visit feel familiar. Our menu is carefully curated to combine comfort, creativity, and quality, ensuring every meal brings a moment of satisfaction.
                                        From the first bite of a juicy smash patty to the smooth finish of a handcrafted shake, every detail is designed to deliver joy.
                                    </p>
                                </div>
                                
                                <div class="blog-meta mb-xl-20">
                                    <h5 class="blog-title text-light-black">Where does it come from?</h5>
                                    <p class="text-light-white mb-xl-20">
                                        Our culinary inspiration comes from the vibrant food scene of Los Angeles—where street food culture meets gourmet innovation. Each recipe is rooted in authenticity, influenced by the city’s rich blend of cultures, flavors, and cooking techniques.
                                        We source fresh local produce, premium meat blends, and handcrafted sauces that elevate every burger into an experience worth remembering.
                                    </p>
                                    <p class="text-light-white">
                                        The passion behind our menu comes from years of experimentation, chef-crafted flavor profiles, and a commitment to using ingredients that speak for themselves. Whether it's our signature LA Classic or our spicy house special, every item has a story and a purpose on our menu.
                                    </p>
                                </div>
                                
                                <div class="blog-meta mb-xl-20">
                                    <h5 class="blog-title text-light-black">Where can I get that food?</h5>
                                    <p class="text-light-white">
                                        You can enjoy LA Burgers at any of our branches or by ordering online for delivery and takeaway. Each store has been designed to offer a welcoming atmosphere for families, friends, and food lovers.
                                        Whether you’re craving a late-night bite or planning a casual meal with your group, our locations are easily accessible and open throughout the week.
                                        For added convenience, customers can also order through our mobile app or partner delivery platforms for fast, reliable service.
                                    </p>
                                </div>
                                
                                <div class="blog-meta mb-xl-20">
                                    <h5 class="blog-title text-light-black">Why do we order from there?</h5>
                                    <p class="text-light-white">
                                        Customers keep returning because LA Burgers consistently delivers value—great flavors, generous portions, and friendly service. Our chefs prepare every dish fresh to order, ensuring every bite tastes exactly the way it should.
                                        Add to that our wide variety of signature burgers, sides, shakes, and meal bundles, and it’s easy to see why we’ve become a favorite spot for burger lovers.
                                    </p>
                                </div>
                                
                                <blockquote>
                                    <p>"Food tastes better when crafted with passion—our dishes are inspired by global flavors but grounded in pure authenticity."</p>
                                </blockquote>
<!--                                 
                                <div class="comment-box">
                                    <div class="section-header-left">
                                        <h3 class="text-light-black header-title">Comments</h3>
                                    </div>
                                    <div class="review-box">
                                        <div class="review-user">
                                            <div class="review-user-img">
                                                <img src="assets/img/blog-details/40x40/user-1.png" class="rounded-circle" alt="#">
                                                <div class="reviewer-name">
                                                    <p class="text-light-black fw-600">Sarra <small class="text-light-white fw-500">New York, (NY)</small>
                                                    </p> <i class="fas fa-trophy text-black"></i><span class="text-light-black">Top Reviewer</span>
                                                </div>
                                            </div>
                                            <div class="review-date"> <span class="text-light-white">Sep 20, 2022</span>
                                            </div>
                                        </div>
                                        <div class="ratings"> <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="ml-2 text-light-white">2 days ago</span>
                                        </div>
                                        <p class="text-light-black">Delivery was fast and friendly. Food was not great especially the salad. Will not be ordering from again. Too many options to settle for this place.</p>
                                    </div>
                                    <div class="review-box comment-reply">
                                        <div class="review-user">
                                            <div class="review-user-img">
                                                <img src="assets/img/blog-details/40x40/user-2.png" class="rounded-circle" alt="#">
                                                <div class="reviewer-name">
                                                    <p class="text-light-black fw-600">Sarra <small class="text-light-white fw-500">New York, (NY)</small>
                                                    </p> <i class="fas fa-trophy text-black"></i><span class="text-light-black">Top Reviewer</span>
                                                </div>
                                            </div>
                                            <div class="review-date"> <span class="text-light-white">Sep 20, 2022</span>
                                            </div>
                                        </div>
                                        <div class="ratings"> <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="ml-2 text-light-white">2 days ago</span>
                                        </div>
                                        <p class="text-light-black">Delivery was fast and friendly. Food was not great especially the salad. Will not be ordering from again. Too many options to settle for this place.</p>
                                    </div>
                                    <div class="review-box">
                                        <div class="review-user">
                                            <div class="review-user-img">
                                                <img src="assets/img/blog-details/40x40/user-3.png" class="rounded-circle" alt="#">
                                                <div class="reviewer-name">
                                                    <p class="text-light-black fw-600">Sarra <small class="text-light-white fw-500">New York, (NY)</small>
                                                    </p> <i class="fas fa-trophy text-black"></i><span class="text-light-black">Top Reviewer</span>
                                                </div>
                                            </div>
                                            <div class="review-date"> <span class="text-light-white">Sep 20, 2022</span>
                                            </div>
                                        </div>
                                        <div class="ratings"> <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="ml-2 text-light-white">2 days ago</span>
                                        </div>
                                        <p class="text-light-black">Delivery was fast and friendly. Food was not great especially the salad. Will not be ordering from again. Too many options to settle for this place.</p>
                                    </div>
                                    <div class="review-box comment-reply">
                                        <div class="review-user">
                                            <div class="review-user-img">
                                                <img src="assets/img/blog-details/40x40/user-1.png" class="rounded-circle" alt="#">
                                                <div class="reviewer-name">
                                                    <p class="text-light-black fw-600">Sarra <small class="text-light-white fw-500">New York, (NY)</small>
                                                    </p> <i class="fas fa-trophy text-black"></i><span class="text-light-black">Top Reviewer</span>
                                                </div>
                                            </div>
                                            <div class="review-date"> <span class="text-light-white">Sep 20, 2022</span>
                                            </div>
                                        </div>
                                        <div class="ratings"> <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="text-yellow fs-16">
                        <i class="fas fa-star"></i>
                      </span>
                                            <span class="ml-2 text-light-white">2 days ago <i class="fas fa-heart"></i></span>
                                        </div>
                                        <p class="text-light-black">Delivery was fast and friendly. Food was not great especially the salad. Will not be ordering from again. Too many options to settle for this place.</p>
                                    </div>
                                </div> -->
                                <!-- <div class="comment-form">
                                    <div class="section-header-left">
                                        <h3 class="text-light-black header-title">Leave a Reply</h3>
                                    </div>
                                    <form>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="text-light-black fw-600">Full Name</label>
                                                    <input type="text" name="#" class="form-control form-control-submit" placeholder="Full Name">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="text-light-black fw-600">Email Address</label>
                                                    <input type="email" name="#" class="form-control form-control-submit" placeholder="Email Address">
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label class="text-light-black fw-600">Your Comment</label>
                                                    <textarea class="form-control form-control-submit" name="#" rows="6" placeholder="Your Comment"></textarea>
                                                </div>
                                                <button type="submit" class="btn-second btn-submit full-width">Send</button>
                                            </div>
                                        </div>
                                    </form>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <aside class="col-lg-3">
                <!-- <app-blogrightsidebar></app-blogrightsidebar> -->
            </aside>
            </div>
        </div>
    </section>

    <app-footer1></app-footer1>